import { QueryClientProvider } from '@tanstack/react-query'
import type { ReactNode } from 'react'

import { getQueryClient } from './'

interface APIQueryProviderProps {
    children: ReactNode
}

export const APIQueryProvider = ({ children }: APIQueryProviderProps) => {
    return <QueryClientProvider client={getQueryClient()}>{children}</QueryClientProvider>
}
